import { render, staticRenderFns } from "./TotalOrderByStatus.vue?vue&type=template&id=41b67501&"
import script from "./TotalOrderByStatus.vue?vue&type=script&lang=js&"
export * from "./TotalOrderByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports